
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_61034_19249)"}},[_c('path',{attrs:{"d":"M12 0h12v12H12V0zM0 12h12v12H0V12z","fill":"#fff","fill-opacity":".3"}}),_c('path',{attrs:{"d":"M4 3v1h16V2H4v1zm17 1h-1v16h2V4h-1zm-1 17v-1H4v2h16v-1zM3 20h1V4H2v16h1zm1 1v-1H2a2 2 0 002 2v-1zm17-1h-1v2a2 2 0 002-2h-1zM20 3v1h2a2 2 0 00-2-2v1zM4 3V2a2 2 0 00-2 2h2V3z","fill":"#FDFDFD"}}),_c('path',{attrs:{"d":"M12 3v18M20 12H3","stroke":"#FDFDFD","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M9.5 7.5a2 2 0 11-4 0 2 2 0 014 0zM15.87 5.856a.8.8 0 011.26 0l.062.094 1.213 2.1a.8.8 0 01-.692 1.2h-2.426a.8.8 0 01-.692-1.2l1.213-2.1.062-.094zM9.5 17.8a.7.7 0 01-.7.7H6.2a.7.7 0 01-.7-.7v-2.6a.7.7 0 01.7-.7h2.6a.7.7 0 01.7.7v2.6z","fill":"#FDFDFD"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_61034_19249"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    